import React, { PropsWithChildren } from 'react'
import { getValue } from 'firebase-utils'
import { makeStyles } from '@material-ui/core'
import { TextFieldType } from 'foundations-library/types'
import { Divider, TextField, Typography } from 'foundations-library/components'
import InfoSection from '../shared/InfoSection'
import EmphasizedSection from '../shared/EmphasizedSection'

const jss = (theme) => {
    return {
        flex20: {
            display: 'flex',
            flexDirection: 'column',
            gap: 20
        },
        infosection: {
            padding: '0 !important'
        },
        divider: {
            margin: 0
        }
    }
}

const useStyles = makeStyles(jss)
type PropsType = {
    sample: string
} & TextFieldType
/**
 *
 */
const PrivacyPolicyLink = ({ children, sample, ...props }: PropsWithChildren<PropsType>): JSX.Element => {
    const styles = useStyles()
    const infoText = getValue('sms_enrollment_campaigns_1st_link_to_privacy_policy_infotip')

    return <EmphasizedSection className={styles.flex20}>
        <TextField {...props} />
        {
            !props.disabled &&
            <div className={styles.flex20}>
                {
                    infoText && <InfoSection className={styles.infosection} data-testid='usage-infosection'>
                        <div dangerouslySetInnerHTML={{ __html: infoText }} />
                    </InfoSection>
                }
                {
                    sample && <EmphasizedSection color='neutral-100'>
                        <>
                            <Typography variant='subtitle3'>
                                Sample SMS privacy policy:
                            </Typography>
                            <Typography variant='body3'>
                                <div dangerouslySetInnerHTML={{ __html: sample }} />
                            </Typography>
                        </>
                    </EmphasizedSection>
                }
            </div>
        }
        {
            children &&
            <div>
                <Divider marginTop={0} />
                {children}
            </div>
        }
    </EmphasizedSection>
}

export default PrivacyPolicyLink
